import { api } from "./api";

const LIMITS = { image: 20, video: 50, file: 20, audio: 10 };
const DOC_EXT = /\.(pdf|docx?|xlsx?|csv|txt|pptx?|rtf|odt|ods|zip)$/i;

export const fileKind = (f) => {
  if (f.type.startsWith("image/")) return "image";
  if (f.type.startsWith("audio/")) return "audio";
  if (f.type.startsWith("video/")) return "video";
  if (DOC_EXT.test(f.name)) return "file";
  return null;
};

// Returns an error string or null.
export const checkFile = (f) => {
  const k = fileKind(f);
  if (!k) return `${f.name}: file type not supported`;
  if (f.size > LIMITS[k] * 1024 * 1024) return `${f.name}: too large (max ${LIMITS[k]}MB)`;
  return null;
};

export const uploadFile = async (file, { sid, onProgress }) => {
  const name = file.name || `pasted-${Date.now()}.png`;
  const { data } = await api.post("/chat/uploads/init", { name, type: file.type, size: file.size, sid });
  const size = data.chunk_size;
  for (let off = 0; off < file.size; off += size) {
    await api.post(`/chat/uploads/${data.upload_id}/chunk`, file.slice(off, off + size), { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.min(99, Math.round(((off + size) / file.size) * 100)));
  }
  const res = await api.post(`/chat/uploads/${data.upload_id}/complete`);
  onProgress?.(100);
  return res.data;
};

export const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
